var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "group-filter-panel", class: { collapse: _vm.collapse } },
    [
      _c(
        "div",
        {
          staticClass: "group-filter-header",
          on: {
            click: function ($event) {
              _vm.collapse = !_vm.collapse
            },
          },
        },
        [
          _c("h1", [_vm._v("动态分组过滤")]),
          _vm._v(" "),
          _c("VIcon", { attrs: { icon: "mdi-chevron-up" } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "group-item group-select-all" },
        [
          _c(
            "CheckBox",
            {
              model: {
                value: _vm.allChecked,
                callback: function ($$v) {
                  _vm.allChecked = $$v
                },
                expression: "allChecked",
              },
            },
            [_vm._v(" 全选 ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.groups, function (group, index) {
        return _c(
          "div",
          { key: index, staticClass: "group-item" },
          [
            _c(
              "CheckBox",
              {
                model: {
                  value: group.checked,
                  callback: function ($$v) {
                    _vm.$set(group, "checked", $$v)
                  },
                  expression: "group.checked",
                },
              },
              [_vm._v("\n      " + _vm._s(group.name) + "\n    ")]
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }